import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  Label,
  Modal,
} from "reactstrap"
import { useNavigate, Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import CustomTable from "../../Custom/TableWithRemotePagination"
import classnames from "classnames"
import * as Yup from "yup"
import { Field, FormikProvider, useFormik } from "formik"
import CustomSelect from "Custom/CustomSelect"
import { get, post } from "helpers/api_helper"
import { GET_PurchaseOrderList, POST_DeleteCancelPO } from "helpers/url_helper"
import { Spin } from "antd"
import swal from "sweetalert"
import SwalError from "Custom/SwalError"
import moment from "moment"
import PODetails from "./details"

const PurchaseOrder = props => {
  const navigate = useNavigate()
  const [totalSize, setTotalSize] = useState(0)
  // const [isDraft, setIsDraft] = useState(false)
  const [hide, setHide] = useState(1)
  const [mode, setMode] = useState(1)
  const [viewMore, setViewMore] = useState(false)
  const [fulfillmentPlanModal, setFulfillmentPlanModal] = useState(false)
  const [search, setSearch] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [purchaseOrderList, setPurchaseOrderList] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10)
  const [POListData, setPOListData] = useState([])
  const [ID, setID] = useState("")

  const [showSwalError, setShowSwalError] = useState(false)
  const [swalErrorMsg, setSwalErrorMsg] = useState("")

  var Auth = JSON.parse(localStorage.getItem("authUser"))

  const columns = [
    {
      text: (
        <>
          <Input
            type="checkbox"
            className="form-check-input"
            id="Add"
            checked={false}
          />
          &nbsp; Date
        </>
      ),
      dataField: "Date",
      style: { minWidth: "150px" },
    },
    {
      text: "Purchase Order",
      dataField: "PurchaseOrder",
      style: { minWidth: "150px" },
    },
    {
      text: "Reference",
      dataField: "Reference",
      style: { minWidth: "150px" },
    },
    {
      text: "Vendor Name",
      dataField: "VendoreName",
      style: { minWidth: "200px" },
    },
    {
      text: "Status",
      dataField: "Status",
      style: { minWidth: "100px" },
    },
    {
      text: (
        <>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Amount
        </>
      ),
      dataField: "Amount",
      style: { minWidth: "150px", textAlign: "right" },
    },
    {
      text: "Expected Delivery Date",
      dataField: "ExpectedDeliveryDate",
      style: { minWidth: "250px" },
    },
    {
      text: "Actions",
      dataField: "Actions",
      style: { maxWidth: "90px", minWidth: "70px" },
    },
  ]


  const getData = (page = 1, sizePerPage = 10) => {
    setIsLoading(true)
    get(
      GET_PurchaseOrderList +
      "?page=" +
      page +
      "&paginate=" +
      sizePerPage +
      (Search ? "&search=" + Search : "") +
      (SearchByColumn ? "&column_filter=" + SearchByColumn : "") +
      (Status ? "&status_filter=" + Status : "")
    )
      .then(res => {
        if (res?.data?.data?.length > 0) {
          setPurchaseOrderList(
            res?.data?.data?.map((e, index) => {
              return {
                Date: (
                  <>
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      id="Add"
                      checked={false}
                    />{" "}
                    &nbsp;
                    {e.purchase_order_date
                      ? moment(e.purchase_order_date)
                        .format("DD-MMM-YYYY")
                        .replace(/^\-/, "")
                      : ""}
                  </>
                ),
                PurchaseOrder: (
                  <>
                    {Auth?.permissions?.filter(
                      x => x.resource_id == 5 && x.view_per == 1
                    )?.length > 0 ? (
                      <Link
                        onClick={() => {
                          setHide(2)
                          setID(e.id)
                        }}
                      >
                        {e.purchase_order_no}
                      </Link>
                    ) : (
                      e.purchase_order_no
                    )}
                  </>
                ),
                Reference: e.reference_estimate,
                VendoreName: e.contact?.company_name,
                Status: (
                  <>
                    <text
                      style={{
                        color:
                          e.po_status === "draft"
                            ? "grey"
                            : e.po_status === "issued"
                              ? "#798ad8"
                              : "green",
                        textTransform: "uppercase",
                      }}
                    >
                      {e.po_status}
                    </text>
                  </>
                ),
                Amount: (
                  <>Rs. {e.total ? parseFloat(e.total).toFixed(2) : "0.00"}</>
                ),
                ExpectedDeliveryDate: e.expected_delivery_date,
                Actions: (
                  <>
                    <div className="d-flex">
                      {e.po_status.toLowerCase() !== "sent" &&
                        Auth?.permissions?.filter(
                          x => x.resource_id == 5 && x.edit_per == 1
                        )?.length > 0 && (e?.po_status == "ammend_request" || e?.po_status == "draft") ? (
                        <Link
                          className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                          style={{
                            width: "25px",
                            height: "25px",
                            padding: "0px",
                          }}
                          to={`/edit-purchase-order/${e.id}`}
                          title="Edit"
                          disabled={e.po_status === "draft" ? false : true}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "#17a98c" }}
                          ></i>
                        </Link>
                      ) : (
                        <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                      )}
                      &nbsp;
                      {Auth?.permissions?.filter(
                        x => x.resource_id == 5 && x.delete_per == 1
                      )?.length > 0 && e?.po_status == "draft" ? (
                        <>
                          {e.po_status === "draft" ? <Button
                            className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                            style={{
                              width: "25px",
                              height: "25px",
                              padding: "0px",
                            }}
                            title="Delete"
                            onClick={() => {
                              delete_po(e.id)
                            }}
                          >
                            <i
                              className="fas fa-trash-alt"
                              style={{
                                color: "red",
                              }}
                            ></i>
                          </Button> : ''}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                ),
              }
            })
          )
          setTotalSize(res?.data?.total)
          setIsLoading(false)
          setPOListData(res?.data?.data)
        } else {
          setPurchaseOrderList([])
          setTotalSize(0)
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
    setCurrentPage(page)
    setCurrentSizePerPage(sizePerPage)
  }

  const validationSchemaFilter = Yup.object().shape({})

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Status: "",
      Search: "",
      SearchByColumn: "",
    },
    validateOnBlur: false,
  })

  const {
    setFieldValue,
    values: { Search, Status, SearchByColumn },
  } = formikFilter

  const handleValidSubmitFilter = values => { }

  useEffect(() => {
    getData()
  }, [Search, SearchByColumn, Status])

  const purchaseOrderOptions = [
    { label: "Purchase Order", value: "purchase_order" },
    { label: "Vendor Name", value: "vendor_name" },
  ]

  const statusOption = [
    { label: "DRAFT", value: "draft" },
    { label: "APPROVAL", value: "approval" },
    { label: "PENDING", value: "pending" },
    { label: "SEND", value: "send" },
  ]

  const cancel_po = ID => {
    swal({
      title: "Are you sure you want to cancel the purchase order?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(willDo => {
      if (willDo) {
        cancel_poConfirm(ID)
      }
    })
  }

  const cancel_poConfirm = async ID => {
    setIsLoading(true)
    await post(POST_DeleteCancelPO, {
      po_id: ID,
      action: "canceled",
    })
      .then(response => {
        if (response?.status == 200) {
          swal({
            title: "Cancel Purchase Order",
            text: response?.message,
            icon: "success",
            button: "OK",
          })
          getData(currentPage, currentSizePerPage)
          setIsLoading(false)
        } else {
          // swal("Error!", response?.message, "error")
          if (typeof response?.message == "string") {
            swal({
              title: "Error!",
              text: response.message,
              icon: "error",
              button: "OK",
            })
          } else {
            setSwalErrorMsg(response?.message)
            setShowSwalError(true)
          }
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }

  const delete_po = ID => {
    swal({
      title: "Are you sure you want to delete the purchase order?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(willDo => {
      if (willDo) {
        delete_poConfirm(ID)
      }
    })
  }

  const delete_poConfirm = async ID => {
    setIsLoading(true)
    await post(POST_DeleteCancelPO, {
      po_id: ID,
      action: "delete",
    })
      .then(response => {
        if (response?.status == 200) {
          swal({
            title: "Delete Purchase Order",
            text: response?.message,
            icon: "success",
            button: "OK",
          })
          getData(currentPage, currentSizePerPage)
          setIsLoading(false)
        } else {
          // swal("Error!", response?.message, "error")
          if (typeof response?.message == "string") {
            swal({
              title: "Error!",
              text: response.message,
              icon: "error",
              button: "OK",
            })
          } else {
            setSwalErrorMsg(response?.message)
            setShowSwalError(true)
          }
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }

  return (
    <React.Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>{"Purchase Orders"} | Katlax OMS</title>
          </MetaTags>

          <Container fluid>
            {hide === 1 ? (
              <>
                <Row className="mt-3">
                  <Col lg={6}>
                    <div className="mt-2" style={{ fontSize: "large" }}>
                      <b>Purchase Orders</b>
                    </div>
                  </Col>
                  <Col lg={6} style={{ textAlign: "end" }}>
                    {Auth?.permissions?.filter(
                      x => x.resource_id == 5 && x.create_per == 1
                    )?.length > 0 ? (
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          navigate("/add-purchase-order")
                        }}
                      >
                        Add Purchase Order
                      </button>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="col-12">
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row>
                          <Col lg={12}>
                            <Row>
                              <Col lg={3} sm={6} md={3}>
                                <div className="form-group has-search">
                                  <span className="fa fa-search form-control-feedback"></span>
                                  {/* <Field
                                    type="text"
                                    name="Search"
                                    component={CustomInput}
                                    placeholder="Search"
                                  /> */}
                                  <Input
                                    type="text"
                                    name="Search"
                                    className="form-control"
                                    placeholder="Search"
                                    value={Search}
                                    onChange={e => {
                                      //setSearch(e.target.value)
                                      formikFilter.setFieldValue(
                                        "Search",
                                        e.target.value
                                      )
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg={2} sm={6} md={2}>
                                <Field
                                  name="SearchByColumn"
                                  placeholder={"By Column"}
                                  component={CustomSelect}
                                  options={purchaseOrderOptions}
                                />
                              </Col>
                              <Col lg={2} md={2}>
                                <Field
                                  name="Status"
                                  placeholder={"Status"}
                                  component={CustomSelect}
                                  options={statusOption}
                                />
                              </Col>
                              <Col
                                lg={2}
                                className="mt-1"
                                style={{ textAlign: "left" }}
                              >
                                <div
                                  onClick={() => {
                                    //setSearch("")
                                    formikFilter.setFieldValue("Status", "")
                                    formikFilter.setFieldValue("Search", "")
                                    formikFilter.setFieldValue(
                                      "SearchByColumn",
                                      ""
                                    )
                                  }}
                                >
                                  <i
                                    className="mdi mdi-filter-remove"
                                    style={{
                                      fontSize: "20px",
                                      color: "#4a539f",
                                    }}
                                  ></i>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                    <Card>
                      <CardBody className="table-fixed">
                        <CustomTable
                          keyField="Vendor"
                          columns={columns}
                          data={purchaseOrderList}
                          totalSize={totalSize}
                          getData={getData}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : <PODetails
              hooks={{
                setShowSwalError, setSwalErrorMsg, setIsLoading,
                navigate, POListData, ID, Auth, purchaseOrderList,
                viewMore, setViewMore, setHide,
                classnames, mode
              }}
            />}
            <SwalError
              showError={showSwalError}
              setShowError={setShowSwalError}
              ErrorMsg={swalErrorMsg}
            ></SwalError>
          </Container>
        </div>
        <Modal isOpen={fulfillmentPlanModal} centered={true} size="lg">
          <div className="modal-header mdl_header">
            <h5 className="modal-title mt-0">
              <text style={{ color: "black" }}>
                {"Fulfillment Planning Details"}
              </text>{" "}
            </h5>
            <button
              type="button"
              className="btn close mt-2"
              onClick={() => setFulfillmentPlanModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr className="table-light">
                    <th style={{ minWidth: "250px" }}>ITEMS & DESCRIPTION</th>
                    <th style={{ minWidth: "150px" }}>ORDERED</th>
                    <th style={{ minWidth: "200px" }}>
                      FULFILLMENT PLANNING DATES
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <img
                        src={
                          "https://cdn.pixabay.com/photo/2017/11/10/04/47/image-2935360_1280.png"
                        }
                        alt=""
                        className="avatar-xs rounded-square"
                        style={{
                          borderRadius: "5px",
                        }}
                      />
                      &nbsp;<span> Raw Material</span>
                    </td>
                    <td>
                      1235 Box <br></br>
                      Pending-31
                    </td>
                    <td>
                      19-Jun-2023 <br></br>
                      20-Jun-2023
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr></hr>
            <Row>
              <Col lg={12} style={{ textAlign: "right" }}>
                <button
                  className="btn btn-light"
                  type="button"
                  onClick={() => {
                    setFulfillmentPlanModal(false)
                  }}
                >
                  Cancel
                </button>
              </Col>
            </Row>
          </div>
        </Modal>
      </Spin>
    </React.Fragment>
  )
}
PurchaseOrder.propTypes = {
  t: PropTypes.any,
}

export default withRouter(withTranslation()(PurchaseOrder))
